import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    let consult = `Por favor, realiza la interpretacion de la Tirada de Tarot Evolutivo para ${
        data.consultante.name
    } de signo zodiacal ${
        data.consultante.zodiac
    }, ten en cuenta en esta tirada su signo zodiacal y su personalidad número ${
        data.consultante.personality
    } según la numerología, ${
        data.consulta.length > 0 ? ' y adapta la tirada al siguiente aspecto: ' + data.consulta : ''
    } y organiza la tirada de la siguiente forma: 1) Tirada del Camino de la Vida: ${formatCardLabel(cards[0])} en el pasado (eventos, patrones o influencias del pasado que han moldeado al consultante y que siguen afectándolo), ${formatCardLabel(cards[1])} en el presente (situación actual del consultante, su estado mental, emocional o espiritual, y los factores que están en juego ahora mismo), ${formatCardLabel(cards[2])} en los desafíos que debe enfrentar para avanzar en el camino de la vida, ${formatCardLabel(cards[3])} en las oportunidades para superar desafíos y avanzar en su evolución, ${formatCardLabel(cards[4])} en la lección de vida a aprender para evolucionar y avanzar y ${formatCardLabel(cards[5])} en el potencial futuro si el consultante sigue el camino sugerido, incorporando las lecciones y aprovechando las oportunidades; 2) Tirada de las Lecciones de Vida: ${formatCardLabel(cards[6])} en la lección actual que el consultante está enfrentando, ${formatCardLabel(cards[7])} en los bloqueos, ${formatCardLabel(cards[8])} en los recursos internos, ${formatCardLabel(cards[9])} en las influencias externas y ${formatCardLabel(cards[10])} en el siguiente paso evolutivo; y 3) Tirada del Ser Superior: ${formatCardLabel(cards[11])} en el Yo inferior, ${formatCardLabel(cards[12])} en el Yo consciente y ${formatCardLabel(cards[13])} en el Yo superior. Luego de las interpretaciones, ofrece un resúmen con título del Camino de la vida, otro resúmen con título de las Lecciones de Vida y otro resúmen con título del Ser Superior. Al final ofrece recomendaciones para lograr los objetivos y el premio por evolucionar. Dirígete directamente al consultante. Utiliza la narrativa, no hagas listas numeradas.`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
